import achievementsChoicer from './achivementsChoicer';

(() => {
  achievementsChoicer();
})();
